import { useState, useEffect } from 'react'
import BlueBulb from '../../assets/icons/inventory/BlueBulb.svg'
import BlueBlubSelected from '../../assets/icons/inventory/SelectedBuleBulb.svg'

export const markerIcon = (selected) => {
  let icon = BlueBulb
  let anchorPosition = new window.google.maps.Point(0, 32)
  if (selected) {
    icon = BlueBlubSelected
    anchorPosition = new window.google.maps.Point(6, 38)
  }

  return {
    url: icon,
    origin: new window.google.maps.Point(0, 0),
    anchor: anchorPosition,
  }
}

const LoadingInvAsset = (map, assets,InfoClick) => {

  const [markers, setMarkers] = useState([])

  useEffect(()=>{
    var infowindow
    let prev_marker = []
    if (map && assets) {
      setMarkers(
        assets && assets.map((asset) => {
          const icon = markerIcon(false)
          
          const marker = new window.google.maps.Marker({
            map,
            icon,
            position: new window.google.maps.LatLng(asset.Latitude, asset.Longitude),
            title: `${asset.Location_ID}`,
            data: asset,
          })
      
          marker.addListener("click", (ev) => {
            map.panTo(marker.getPosition())
            prev_marker.push(marker)
            if(prev_marker.length === 2){
              prev_marker[0].setIcon(markerIcon(false))
            }
            if (infowindow) {
              if(prev_marker.length > 1){
                prev_marker.shift()
                infowindow.close()
              }
            }
            marker.setIcon(markerIcon(true))
            infowindow = new window.google.maps.InfoWindow({
              pixelOffset: new window.google.maps.Size(-4, 0),
            })
            InfoClick && InfoClick(asset, map, marker, infowindow)
          })
          map.addListener("click",(ev) =>{
            if(marker.open){
              infowindow.close()
              marker.setIcon(markerIcon(false))
              marker.open = false
            }
          })
          return marker
        })
      )
    }
    return () => {
      markers &&
        markers.forEach((marker) => {
          marker.setMap(null)
        })
      setMarkers([])
    }
    // eslint-disable-next-line
  },[map, assets, InfoClick])
  return markers
}

export default LoadingInvAsset
